import React, { useState, useEffect, useRef } from "react";
import { Theme, FormControl } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Button from "../components/custom-button";
import Icon from "../components/icon";
import axios from "axios";
import RoleRadio from "../components/role-radio";
import { Modal } from "rsuite";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import FormInput from "../components/form-input";
import { useHistory, useParams } from "react-router-dom";
import { roomStore } from "../stores/room";
import { genUid } from "../utils/helper";
import MD5 from "js-md5";
import { globalStore, roomTypes } from "../stores/global";
import { t } from "../i18n";
import _ from "lodash";
import { remoteConfig } from "../firebase";
import { useAuth } from "../services/auth-check";

import LangSelect from "../components/lang-select";
import GlobalStorage from "../utils/custom-storage";
import Language from "@material-ui/icons/Language";

import {
  API_COMMON_URL,
  API_V1_USERS,
  COPY_LINK,
} from "../services/ihr-meet-api";

const useStyles = makeStyles((theme: Theme) => ({
  formControl: {
    minWidth: "300px",
    maxWidth: "300px",
  },
}));

type SessionInfo = {
  roomName: string;
  roomType: any;
  yourName: string;
  role: string;
  password: string;
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
  room: string;
  codePassword: string;
  adminPassword: string;
};

const defaultState: SessionInfo = {
  roomName: "",
  roomType: "",
  role: "",
  yourName: "",
  password: "",
  currentPassword: "",
  newPassword: "",
  confirmPassword: "",
  room: "",
  codePassword: "",
  adminPassword: "",
};

function HomePage() {
  const [lang, setLang] = useState<string>("");

  document.title = t(`home.short_title.title`);
  const classes = useStyles();
  const history = useHistory();
  const RoomData1 = JSON.parse(
    sessionStorage.getItem("LoginRoomData") as string
  );
  const UserData = JSON.parse(localStorage.getItem("UserFullData") as string);

  const handleSetting = (evt: any) => {
    history.push({ pathname: `/settings` });
    setSettings(true);
    setHomeActive(false);
    setProfile(false);
  };

  const ref = useRef<boolean>(false);

  useEffect(() => {
    if ((params.roomCode && UserData) || RoomData1) {
      axios
        .get(
          `${API_COMMON_URL}/room-by-code/${
            params.roomCode ? params.roomCode : RoomData1.code
          }`
        )
        .then((codeRes) => {
          if (
            codeRes.data.data.is_active ||
            codeRes.data.data.expired_date === "null"
          ) {
            let data = codeRes.data.data;
            let currentDate = new Date();
            let date = data.expired_date
              ? new Date(data.expired_date)
              : "nullable";
            if (date >= currentDate || date === "nullable") {
              localStorage.setItem("RoomData", `${JSON.stringify(data)}`);
              if (data.is_active_password) {
                setPassword(true);
                setRoomInfo(data);
              } else {
                session.roomType = codeRes.data.data.room_type_id;
                session.roomName = codeRes.data.data.code;
                if (!roomTypes[session.roomType]) return;
                const path = roomTypes[session.roomType].path;
                const payload = {
                  uid: genUid(),
                  rid: `${session.roomType}${MD5(session.roomName)}`,
                  role: "student",
                  roomName: codeRes.data.data.code,
                  roomType: codeRes.data.data.room_type_id,
                  video: 0,
                  audio: 1,
                  chat: 1,
                  share: 0,
                  account: UserData.name,
                  rtmToken: "",
                  boardId: "",
                  linkId: 0,
                  sharedId: 0,
                  lockBoard: 0,
                  grantBoard: 0,
                };
                ref.current = true;
                globalStore.showLoading();
                roomStore
                  .loginAndJoin(payload)
                  .then(() => {
                    history.push(`/classroom/${path}`);
                  })
                  .catch((err: any) => {
                    if (err.reason) {
                      globalStore.showToast({
                        type: "rtmClient",
                        message: t("toast.rtm_login_failed_reason", {
                          reason: err.reason,
                        }),
                      });
                    } else {
                      globalStore.showToast({
                        type: "rtmClient",
                        message: t("toast.rtm_login_failed"),
                      });
                    }
                    console.warn(err);
                  })
                  .finally(() => {
                    ref.current = false;
                    globalStore.stopLoading();
                  });
              }
            } else {
              globalStore.showToast({
                type: "error",
                message: t("toast.room_not-working"),
              });
            }
          } else {
            globalStore.showToast({
              type: "error",
              message: t("toast.inActiveRoom"),
            });
          }
        })
        .catch((error) => {
          globalStore.showToast({
            type: "msg",
            message: t("toast.wrongRoomName"),
          });
          history.push(`/`);
        });
    }

    return () => {
      ref.current = true;
    };
  }, []);

  const [session, setSessionInfo] = useState<SessionInfo>(defaultState);

  const [required, setRequired] = useState<any>({} as any);
  const [homeActive, setHomeActive] = React.useState(true);
  const [profileActive, setProfile] = React.useState(false);
  const [profileSettings, setSettings] = React.useState(false);
  const [roomList, getRoomsData] = useState<any[]>([]);
  const [codePasswordState, setPassword] = React.useState(false);
  const [, setRoomInfo] = useState<any>({} as any);

  const [teacherPasswordState, setTeacherPassword] = React.useState(false);

  const [, getUserInfo] = useState<any[]>([]);

  const [open, setOpen] = React.useState(false);

  const [, getCountriesData] = useState<any[]>([]);

  const params = useParams<{ roomCode?: string }>();

  const is_sms_check = remoteConfig.getBoolean("is_check_sms");

  const changelang = (lang: string) => {
    if (lang == "ar") {
      localStorage.setItem("language", `${JSON.stringify("ar")}`);
      document.documentElement.lang = "ar";
      globalStore.setLanguage("ar");
    } else {
      localStorage.setItem("language", `${JSON.stringify("en")}`);
      document.documentElement.lang = "en";
      globalStore.setLanguage("en");
    }
  };

  const handleStart = () => {
    session.roomType = 3;
    session.roomName = UserData.meeting_id;
    session.role = "teacher";
    const path = roomTypes[session.roomType].path;
    const payload = {
      uid: genUid(),
      rid: `${session.roomType}${MD5(session.roomName)}`,
      role: session.role,
      roomName: UserData.meeting_id,
      roomType: 1,
      video: 0,
      audio: 1,
      chat: 1,
      share: 0,
      account: UserData.name,
      rtmToken: "",
      boardId: "",
      linkId: 0,
      sharedId: 0,
      lockBoard: 0,
      grantBoard: 0,
    };
    ref.current = true;
    globalStore.showLoading();
    roomStore
      .loginAndJoin(payload)
      .then(() => {
        history.push(`/classroom/${path}`);
      })
      .catch((err: any) => {
        if (err.reason) {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.rtm_login_failed_reason", { reason: err.reason }),
          });
        } else {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.rtm_login_failed"),
          });
        }
        console.warn(err);
      })
      .finally(() => {
        ref.current = false;
        globalStore.stopLoading();
      });
  };

  React.useEffect(() => {
    if (!is_sms_check) {
      if (!UserData) {
        return;
      }
    } else {
      if (!UserData || !UserData.is_active) {
        return;
      }
    }
    const lang = GlobalStorage.getLanguage().language;

    const data = JSON.parse(localStorage.getItem("UserFullData") as string);

    const fetchData = async () => {
      const response = await axios.get(
        `${API_COMMON_URL}/room-codes?per_page=1000000`
      );
      getRoomsData(response.data.data.data);

      if (data) {
        const userData = await axios.get(`${API_V1_USERS}/${data.id}`);
        getUserInfo(userData.data.data);
        localStorage.setItem(
          "UserFullData",
          `${JSON.stringify(userData.data.data)}`
        );
      }

      const cont = await axios.get(`${API_COMMON_URL}/countries`);
      getCountriesData(cont.data.data);
      const countryDataCode = _.find(
        cont.data.data,
        (country) => country.id === data.country_id
      );
      localStorage.setItem(
        "countryCode",
        `${JSON.stringify(countryDataCode.country_code)}`
      );
    };
    fetchData();
    setLang(lang);
  }, []);

  const handleLogin = (data: any, roleTypeData: any) => {
    session.roomType = RoomData1 ? RoomData1.room_type_id : data.room_type_id;
    if (!roomTypes[session.roomType]) return;
    const path = roomTypes[session.roomType].path;
    const payload = {
      uid: genUid(),
      rid: `${session.roomType}${MD5(
        session.room
          ? session.room
          : RoomData1
          ? RoomData1.code
          : params.roomCode
      )}`,
      role: RoomData1 ? "student" : session.role ? session.role : roleTypeData,
      roomName: session.room
        ? session.room
        : RoomData1
        ? RoomData1.code
        : params.roomCode,
      roomType: session.roomType,
      video: 0,
      audio: 1,
      chat: 1,
      share: 0,
      account: UserData.name,
      rtmToken: "",
      boardId: "",
      linkId: 0,
      sharedId: 0,
      lockBoard: 0,
      grantBoard: 0,
    };
    ref.current = true;
    globalStore.showLoading();
    roomStore
      .loginAndJoin(payload)
      .then(() => {
        history.push(`/classroom/${path}`);
      })
      .catch((err: any) => {
        if (err.reason) {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.rtm_login_failed_reason", { reason: err.reason }),
          });
        } else {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.rtm_login_failed"),
          });
        }
        console.warn(err);
      })
      .finally(() => {
        ref.current = false;
        globalStore.stopLoading();
      });
  };

  const handleSubmit = () => {
    let roomRoleData = UserData.user_type_id === 1 ? "student" : "teacher";

    session.role = session.role
      ? session.role
      : UserData.user_type_id === 2
      ? ""
      : roomRoleData;

    if (!session.role || !session.room) {
      setRequired({ ...required, missingField: t("requiredField") });
      return;
    }
    const is_check = remoteConfig.getBoolean("is_check");
    if (is_check) {
      const roomData = JSON.parse(localStorage.getItem("roomData") as string);
      const room = _.filter(roomList, { code: session.room });

      if (room.length) {
        if (
          (room && room[0].is_active) ||
          (room && room[0].expired_date === "null")
        ) {
          let data = room[0];
          let currentDate = new Date();
          let date = data.expired_date
            ? new Date(data.expired_date)
            : "nullable";
          if (date >= currentDate || date === "nullable") {
            localStorage.setItem("RoomData", `${JSON.stringify(data)}`);
            if (
              session.role === "teacher" &&
              room &&
              room[0]?.is_active_admin_password
            ) {
              setTeacherPassword(true);
              return;
            }
            if (data.is_active_password) {
              setPassword(true);
              setRoomInfo(data);
            } else {
              handleLogin(data, roomRoleData);
            }
          } else {
            globalStore.showToast({
              type: "error",
              message: t("toast.room_not-working"),
            });
          }
        } else {
          globalStore.showToast({
            type: "error",
            message: t("toast.inActiveRoom"),
          });
        }
      } else {
        globalStore.showToast({
          type: "error",
          message: t("toast.wrongRoomName"),
        });
      }
    } else {
      session.roomType = 2;
      if (!roomTypes[session.roomType]) return;
      const path = roomTypes[session.roomType].path;
      const payload = {
        uid: genUid(),
        rid: `${session.roomType}${MD5(session.room)}`,
        role: session.role
          ? session.role
          : UserData.user_type_id === 1
          ? "student"
          : "teacher",
        roomName: session.room,
        roomType: 2,
        video: 0,
        audio: 1,
        chat: 1,
        share: 0,
        account: UserData.name,
        rtmToken: "",
        boardId: "",
        linkId: 0,
        sharedId: 0,
        lockBoard: 0,
        grantBoard: 0,
      };
      ref.current = true;
      globalStore.showLoading();
      roomStore
        .loginAndJoin(payload)
        .then(() => {
          history.push(`/classroom/${path}`);
        })
        .catch((err: any) => {
          if (err.reason) {
            globalStore.showToast({
              type: "rtmClient",
              message: t("toast.rtm_login_failed_reason", {
                reason: err.reason,
              }),
            });
          } else {
            globalStore.showToast({
              type: "rtmClient",
              message: t("toast.rtm_login_failed"),
            });
          }
          console.warn(err);
        })
        .finally(() => {
          ref.current = false;
          globalStore.stopLoading();
        });
    }
  };

  const passwordCheck = (roomData: any) => {
    let roomRoleData =
      params.roomCode || RoomData1
        ? "student"
        : UserData.user_type_id === 1
        ? "student"
        : "teacher";
    globalStore.showLoading();
    const accessToken = JSON.parse(
      localStorage.getItem("accessToken") as string
    );
    const roomCodeCheck = session.room
      ? session.room
      : RoomData1
      ? RoomData1.code
      : params.roomCode;
    axios({
      method: "get",
      url: `${API_COMMON_URL}/room-codes-check-password?password=${session.codePassword}&room_code=${roomCodeCheck}`,
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    })
      .then(
        (response: any) => {
          if (response.data.data) {
            globalStore.showToast({
              type: "msg",
              message: t("toast.correctPassword"),
            });
            setPassword(false);
            handleLogin(roomData, roomRoleData);
          }
        },
        (error: any) => {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.currentPasswordIsWrong", {
              reason: error.message,
            }),
          });
        }
      )
      .finally(() => {
        globalStore.stopLoading();
      });
  };

  const adminPasswordCheck = (roomData: any) => {
    session.role = "teacher";
    let roomRoleData = session.role;
    globalStore.showLoading();
    const accessToken = JSON.parse(
      localStorage.getItem("accessToken") as string
    );
    //return;
    axios({
      method: "get",
      url: `${API_COMMON_URL}/check-password-admin?admin_password=${session.adminPassword}&room_code=${roomData.code}`,
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    })
      .then(
        (response: any) => {
          if (response.data.data) {
            globalStore.showToast({
              type: "msg",
              message: t("toast.correctPassword"),
            });
            setTeacherPassword(false);
            if (roomData.is_active_password) {
              setPassword(true);
            } else {
              handleLogin(roomData, roomRoleData);
            }
          }
        },
        (error: any) => {
          globalStore.showToast({
            type: "rtmClient",
            message: t("toast.currentPasswordIsWrong", {
              reason: error.message,
            }),
          });
        }
      )
      .finally(() => {
        globalStore.stopLoading();
      });
  };

  const handleCodePassword = () => {
    const roomData = JSON.parse(localStorage.getItem("RoomData") as string);
    if (!session.codePassword) {
      setRequired({ ...required, codePassword: t("home.missingPassword") });
      return;
    }
    passwordCheck(roomData);
  };

  const handleAdminPassword = () => {
    globalStore.showLoading();
    const roomData = JSON.parse(localStorage.getItem("RoomData") as string);
    if (!session.adminPassword) {
      setRequired({ ...required, codePassword: t("home.missingPassword") });
      return;
    }
    adminPasswordCheck(roomData);
  };

  const handleClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("UserData");
    localStorage.removeItem("UserFullData");
    localStorage.removeItem("countryCode");
    history.push("/login");
    setOpen(false);
  };

  const [authorized, redirect] = useAuth("HOME");

  if (!authorized) {
    redirect(params.roomCode);
    return null;
  }

  return (
    <>
      <div className={`setting-container`}>
        <div
          onClick={(evt: any) => {
            handleClick();
          }}
          className="logout-button"
        >
          <span style={{ color: "white", cursor: "pointer" }}>
            {t("logout")}
          </span>
          <Icon className="icon-exit-white home-" />
        </div>
        {lang == "ar" ? (
          <button className="lang-btn" onClick={() => changelang("en")}>
            <span>English</span>
            <Language />
          </button>
        ) : (
          <button className="lang-btn" onClick={() => changelang("ar")}>
            <span>عربي</span> <Language />
          </button>
        )}
      </div>
      <Dialog
        className="logout-dialog"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t("areYouSureToLogOut")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirm} name={t("logout")} />
          <Button onClick={handleClose} name={t("close")} />
        </DialogActions>
      </Dialog>
      <div
        className={`flex-container home-cover-web ${JSON.parse(
          localStorage.getItem("language") as string
        )}`}
      >
        <div className="home">
          <div className="header">
            <div className="logo"></div>
          </div>
          <div className="actions">
            <Button
              name={t("start")}
              onClick={handleStart}
              className="start-butt"
            />
            <a
              target="_blank"
              href={`mailto:?subject=دعوة لقاء iHrmeet - قاعة اجتماعات شخصية&body=مرحبا%0D%0D يدعوك ${
                UserData && UserData.name
              } لحضور اجتماع على iHRmeet. %0D الموضوع: غرفة اجتماعات ${
                UserData && UserData.name
              } الشخصية%0D معرف الاجتماع: ${
                UserData && UserData.meeting_id
              } %0D يمكنك تحميل التطبيق من الرابط أدناه %0D http://onelink.to/ihrmeet `}
            >
              <div className="send-invitation">{t("sendInvitation")}</div>
            </a>
          </div>

          <p className="join-meeting text">{t("joinMeeting")}</p>
          <div className="bottom">
            <div className="input">
              <FormControl className={classes.formControl}>
                <FormInput
                  placeholder={t("roomName")}
                  value={session.room}
                  onChange={(val: string) => {
                    setSessionInfo({
                      ...session,
                      room: val.toLowerCase(),
                    });
                  }}
                  requiredText={session.room ? "" : required.missingField}
                />
              </FormControl>
            </div>
            {UserData?.user_type_id === 2 ? (
              <div className="input" style={{ margin: "-16px 0 0 0" }}>
                <FormControl className={classes.formControl}>
                  <RoleRadio
                    value={session.role}
                    onChange={(evt: any) => {
                      setSessionInfo({
                        ...session,
                        role: evt.target.value,
                      });
                    }}
                    requiredText={session.role ? "" : required.missingField}
                  ></RoleRadio>
                </FormControl>
              </div>
            ) : (
              ""
            )}
            <Button name={t("join")} onClick={handleSubmit} />
          </div>
          <div className="id-name-wrapper">
            <div className="circle"></div>
            <p className="id">{t("welcome")}</p>
            <div className="personal-id">
              <div className="name">{UserData.name}</div>
              <div className="flex">
                <Button
                  className="copy-id"
                  onClick={() => {
                    navigator.clipboard.writeText(`${UserData.meeting_id}`);
                    globalStore.showToast({
                      type: "msg",
                      message: t("roomCopied"),
                    });
                  }}
                />
                <h6 className="red">{UserData ? UserData.meeting_id : ""}</h6>
              </div>
            </div>
          </div>

          <div className="icons">
            <Icon
              className={`${homeActive ? "icon-home active" : "icon-home"}`}
              onClick={() => {
                setHomeActive(true);
              }}
            />
            <Icon
              className={`${
                profileActive ? "icon-profile active" : "icon-profile"
              }`}
              onClick={() => {
                //setAddCodeModalShow(true);
                setSettings(false);
                setHomeActive(false);
                setProfile(true);
                history.push(`/edit-profile`);
              }}
            />
            <Icon
              className={`${
                profileSettings ? "icon-setting active" : "icon-setting"
              }`}
              onClick={handleSetting}
            />
          </div>
        </div>

        <Modal
          show={codePasswordState}
          dialogClassName={`change-password-modal ${JSON.parse(
            localStorage.getItem("language") as string
          )}`}
          backdropClassName={"backdrop-change-password-modal"}
          onHide={() => {
            setPassword(false);
          }}
          backdrop
          size={"sm"}
        >
          <Modal.Header />
          <Modal.Body>
            <div className="change-password">
              <h5>{t("roomPassword")}</h5>
              <FormControl className={classes.formControl}>
                <FormInput
                  placeholder={t("password")}
                  value={session.codePassword}
                  onChange={(val: string) => {
                    setSessionInfo({
                      ...session,
                      codePassword: val,
                    });
                  }}
                  type="password"
                  requiredText={required.codePassword}
                />
              </FormControl>
              <Button name={t("submit")} onClick={handleCodePassword} />
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={teacherPasswordState}
          dialogClassName={`change-password-modal ${JSON.parse(
            localStorage.getItem("language") as string
          )}`}
          backdropClassName={"backdrop-change-password-modal"}
          onHide={() => {
            setTeacherPassword(false);
          }}
          backdrop
          size={"sm"}
        >
          <Modal.Header />
          <Modal.Body>
            <div className="change-password">
              <h5>{t("adminPassword")}</h5>
              <FormControl className={classes.formControl}>
                <FormInput
                  placeholder={t("password")}
                  value={session.adminPassword}
                  onChange={(val: string) => {
                    setSessionInfo({
                      ...session,
                      adminPassword: val,
                    });
                  }}
                  type="password"
                  requiredText={required.adminPassword}
                />
              </FormControl>
              <Button name={t("submit")} onClick={handleAdminPassword} />
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
export default React.memo(HomePage);
